import { CampaignBillingAuditRequest, CampaignBillingAuditResponse } from '../../api-models';
import { CampaignBillingAudit } from '../../types/campaigns.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostCampaignBillingAudit extends BaseAdapter<CampaignBillingAuditResponse[]> implements AdapterInterface {
  rawResponse: CampaignBillingAuditResponse[];

  modifiedRequest: CampaignBillingAuditRequest;

  async adaptResponse(request: { organisationDisplayName: string }): Promise<CampaignBillingAudit[]> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/campaign-billing-audit', HTTPMethod.Post, formattedRequest);
    return this.displayResponse();
  }

  async displayResponse(): Promise<CampaignBillingAudit[]> {
    return this.rawResponse.map((item) => ({
      id: item.id,
      channelName: item.channel_name,
      changeAmount: item.change_amount,
      changedAt: item.updated_at,
      changedBy: item.updated_by_email,
    }));
  }

  adaptRequest(request: { organisationDisplayName: string }): CampaignBillingAuditRequest {
    this.modifiedRequest = {
      organisation_display_name: request.organisationDisplayName,
    };
    return this.modifiedRequest;
  }
}
